import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  loadOverview,
  loadProviderStatus,
  loadQueryPages,
  loadRecommendations,
  loadTable,
  updateRecommendation,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(loadProviderStatus.type, send, socket);
  yield takeEvery(loadOverview.type, send, socket);
  yield takeEvery(loadTable.type, send, socket);
  yield takeEvery(loadQueryPages.type, send, socket);
  yield takeEvery(loadRecommendations.type, send, socket);
  yield takeEvery(updateRecommendation.type, send, socket);
}
